<script lang="ts">
    import { beforeNavigate } from '$app/navigation';
    import { page } from '$app/state';
    import { routeGuardAuthClient } from '$src/lib/services/routing/guards/authenticated';

    beforeNavigate(async ({ to }) => {
        const {
            data: { isLoggedIn, market, navigationSlugs }
        } = page;

        if (to) {
            routeGuardAuthClient({
                isLoggedIn,
                pathname: to.url.pathname,
                market,
                navigationSlugs
            });
        }
    });
</script>
